import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Scrollbar from 'react-smooth-scrollbar';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import SidebarContent from './SidebarContent';
import { changeMobileSidebarVisibility } from '../../redux/actions/sidebarActions';

class Sidebar extends PureComponent {
  contactUs(e) {
    e.preventDefault();
    const deskWidget = document.querySelector('.a-desk-widget-email');
    if (deskWidget && 'click' in deskWidget) {
      document.querySelector('.a-desk-widget-email').click();
    }
  }

  changeMobileSidebarVisibility = () => {
    this.props.dispatch(changeMobileSidebarVisibility());
  };

  render() {
    const {
      sidebar: { show, collapse }
    } = this.props;
    const sidebarClass = classNames({
      sidebar: true,
      'sidebar--show': show,
      'sidebar--collapse': collapse
    });

    return (
      <div className={sidebarClass}>
        <div
          className="sidebar__back"
          onClick={this.changeMobileSidebarVisibility}
        />
        <Scrollbar className="sidebar__scroll scroll">
          <div className="sidebar__wrapper sidebar__wrapper--desktop">
            <SidebarContent onClick={() => {}} />
          </div>
          <div className="sidebar__wrapper sidebar__wrapper--mobile">
            <SidebarContent onClick={this.changeMobileSidebarVisibility} />
          </div>
          <button
            className="btn btn-contact-us"
            onClick={this.contactUs.bind(this)}
          >
            contact us
          </button>
        </Scrollbar>
      </div>
    );
  }
}

export default withRouter(
  connect(state => {
    return { sidebar: state.sidebar };
  })(Sidebar)
);



// WEBPACK FOOTER //
// ./src/components/sidebar/Sidebar.js